import MaterialRow from "@/components/MaterialRow/MaterialRow";
import { ViewChapter } from "@/components/ViewChapter/ViewChapter";
import { useAppSelector } from "@/config/store";
import { IEdoChapter } from "@/shared/model/edo-chapter.model";
import { IEdoCourseMaterial } from "@/shared/model/edo-course-material.model";
import { IEdoCourse } from "@/shared/model/edo-course.model";
import { IEdoStudent } from "@/shared/model/edo-student.model";
import { AuthenticationState } from "@/shared/reducers/authentication";
import { ITEMS_PER_PAGE } from "@/shared/util/pagination.constants";
import { Card, List, Pagination } from "@/components/ui";
import axios from "axios";
import { useEffect, useState } from "react";
import { IPaginationBaseState, Translate } from "react-jhipster";

interface INewCourseMaterials {
  student: IEdoStudent;
}

const NewCourseMaterials = (props: INewCourseMaterials) => {
  const { account } = useAppSelector<AuthenticationState>(
    (state) => state.authentication
  );
  const [courseMaterials, setCourseMaterials] = useState<{
    entities: IEdoCourse[];
    loading: boolean;
    totalItems: number;
  }>({ entities: [], loading: false, totalItems: 0 });
  const [paginationState, setPaginationState] = useState<IPaginationBaseState>({
    activePage: 1,
    itemsPerPage: ITEMS_PER_PAGE,
    sort: "createdAt",
    order: "ASC",
  });
  const [viewChapterDialog, setViewChapterDialog] = useState<{
    entity: IEdoChapter | null;
    open: boolean;
  }>({ entity: null, open: false });

  const { student } = props;

  const getCourseMaterials = async () => {
    if (!student?.user?.id) return;
    setCourseMaterials((prev) => ({ ...prev, loading: true }));
    const response = await axios.get<{
      data: IEdoCourse[];
      meta: { totalItems: number };
    }>(`/students/${student?.user.id}/course-materials`, {
      params: {
        page: paginationState.activePage,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      },
    });
    setCourseMaterials({
      entities: response.data.data,
      loading: false,
      totalItems: response.data.meta.totalItems,
    });
  };

  useEffect(() => {
    if (account?.id && student?.userId) getCourseMaterials();
  }, [
    paginationState.activePage,
    paginationState.order,
    paginationState.sort,
    paginationState.itemsPerPage,
    student?.userId,
    account?.id,
  ]);

  const handlePagination = (currentPage: number) =>
    setPaginationState({ ...paginationState, activePage: currentPage });

  const handleRowsPerPage = (rowsPerPage: number) =>
    setPaginationState({
      ...paginationState,
      itemsPerPage: rowsPerPage,
      activePage: 1,
    });

  return (
    <>
      <Card className="flex h-full flex-col overflow-hidden rounded-3xl text-[var(--color-mockup-text-mid)]">
        <div className="flex flex-1 flex-col">
          <div className="border-b border-[var(--color-mockup-border)] px-4 py-3 dark:border-[var(--color-mockup-border)]">
            <h3 className="text-heading font-semibold text-[var(--color-mockup-text)]">
              Materiale didattico
            </h3>
          </div>
          <div className="min-h-0 flex-1">
            {courseMaterials.loading ? (
              <div className="flex justify-center py-8">
                <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
              </div>
            ) : !courseMaterials.entities.length ? (
              <div className="p-4 text-center">
                <span className="text-body text-[var(--color-mockup-text-mid)]">
                  <Translate contentKey="edocendoApp.edoCourseMaterial.home.notFound" />
                </span>
              </div>
            ) : (
              <List className="flex flex-col divide-y divide-[var(--color-mockup-border)]">
                {courseMaterials.entities.map((courseMaterial, i, arr) => (
                  <MaterialRow
                    key={courseMaterial.id}
                    courseMaterial={courseMaterial as any}
                    isLastElement={i === arr.length - 1}
                    onOpenViewChapter={() =>
                      setViewChapterDialog({
                        entity: courseMaterial.chapter,
                        open: true,
                      })
                    }
                    onOpenEditMaterial={null}
                    onOpenDeleteMaterial={null}
                    showSubject={true}
                    extendedDate={true}
                  />
                ))}
              </List>
            )}
          </div>
          <Pagination
            count={courseMaterials.totalItems}
            page={paginationState.activePage - 1}
            rowsPerPage={paginationState.itemsPerPage}
            onPageChange={(p) => handlePagination(p + 1)}
            onRowsPerPageChange={handleRowsPerPage}
            labelRowsPerPage="Righe per pagina:"
          />
        </div>
      </Card>
      <ViewChapter
        open={viewChapterDialog.open}
        chapter={viewChapterDialog.entity}
        onClose={() =>
          setViewChapterDialog({ entity: null, open: false })
        }
      />
    </>
  );
};

export default NewCourseMaterials;
